/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./container.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./container.component";
var styles_ContainerComponent = [i0.styles];
var RenderType_ContainerComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ContainerComponent, data: {} });
export { RenderType_ContainerComponent as RenderType_ContainerComponent };
export function View_ContainerComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_ContainerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-container", [], [[2, "cc-container", null]], null, null, View_ContainerComponent_0, RenderType_ContainerComponent)), i1.ɵdid(1, 114688, null, 0, i2.ContainerComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).containerClass; _ck(_v, 0, 0, currVal_0); }); }
var ContainerComponentNgFactory = i1.ɵccf("cc-container", i2.ContainerComponent, View_ContainerComponent_Host_0, { fullWidth: "fullWidth" }, {}, ["*"]);
export { ContainerComponentNgFactory as ContainerComponentNgFactory };
